import { render, staticRenderFns } from "./ProductDetailCategoryDetailView.vue?vue&type=template&id=121f0a00&scoped=true"
import script from "./ProductDetailCategoryDetailView.vue?vue&type=script&lang=js"
export * from "./ProductDetailCategoryDetailView.vue?vue&type=script&lang=js"
import style0 from "./ProductDetailCategoryDetailView.vue?vue&type=style&index=0&id=121f0a00&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "121f0a00",
  null
  
)

export default component.exports